import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
  type: any;

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    private afs: AngularFirestore,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.type = data;
  }

  ngOnInit() {
  }

  deletePost(): void {
    console.log(this.data)
    this.afs.collection('posts').doc(this.data.key).delete();

    this.dialogRef.close();

    // this.afs.collection('complaints').doc(this.data.key)

  }
  deleteComp() {
    this.afs.collection("complaints").doc(this.data.key).delete();
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }


}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/complaints/dialog/dialog.component.ts